import type { MeResponse } from '../../../shared/types.ts';

export type Page = 'play' | 'stats' | 'leaderboard' | 'how' | 'profile' | 'user-stats';

interface Props {
  page: Page;
  onNavigate: (p: Page) => void;
  me: MeResponse | null;
  participantCount: number;
  connection: 'connecting' | 'open' | 'closed';
  onOpenAuth: () => void;
}

export function Header({ page, onNavigate, me, participantCount, connection, onOpenAuth }: Props): React.ReactElement {
  return (
    <header className="hdr">
      <div className="hdr-inner">
        <button className="brand" onClick={() => onNavigate('play')} aria-label="Go to quiz">
          <span className="brand-dot" />
          <span className="brand-name">witladder</span>
        </button>
        <nav className="nav">
          <button className={page === 'play' ? 'nav-btn active' : 'nav-btn'} onClick={() => onNavigate('play')}>Play</button>
          <button className={page === 'leaderboard' ? 'nav-btn active' : 'nav-btn'} onClick={() => onNavigate('leaderboard')}>Ranking</button>
          <button className={page === 'stats' ? 'nav-btn active' : 'nav-btn'} onClick={() => onNavigate('stats')}>Stats</button>
          <button className={page === 'how' ? 'nav-btn active' : 'nav-btn'} onClick={() => onNavigate('how')}>How it works</button>
          <button className={page === 'profile' ? 'nav-btn active' : 'nav-btn'} onClick={() => onNavigate('profile')}>Profile</button>
        </nav>
        <div className="hdr-right">
          <div className={`live-pill conn-${connection}`} title={connection === 'open' ? 'Connected' : connection === 'connecting' ? 'Reconnecting…' : 'Offline'}>
            <span className="dot" />
            {participantCount} online
          </div>
          {me?.user ? (
            <button className="me-pill" onClick={() => onNavigate('profile')}>
              <span className="me-avatar" style={{ background: me.user.avatarColor }}>{me.user.username.slice(0, 1).toUpperCase()}</span>
              <span className="me-name">{me.user.username}</span>
            </button>
          ) : (
            <button className="me-pill ghost" onClick={onOpenAuth}>Sign in</button>
          )}
        </div>
      </div>
    </header>
  );
}
